/**
 * This is used to define the default feature flags until the connection to LaunchDarkly is completed.
 * @type {import('launchdarkly-react-client-sdk').LDFlagSet} Name of the feature flag and its default value.
 */
const defaultLDFlags = {
  'show-canada-post-banner': false,
  'credit.pass-credit-intent-to-registration': false,
};

module.exports.defaultLDFlags = defaultLDFlags;
